import { IMailTask } from 'modules/accommodations/features/reservations/models';
import API from 'services/api';

interface IProps {
  id: string;
  calculationId: string;
  payload: IMailTask;
}

export const sendTemplateEmail = ({ id, calculationId, payload }: IProps): Promise<null> =>
  API.post(`api/accommodation/templates/${id}/calculations/${calculationId}/send_mail`, payload, {
    params: { isRenter: true },
  }).then(response => response?.data);
